import { useState, useEffect } from "react";
import {
  requestNotificationPermission,
  isNotificationSupported,
  isNotificationGranted,
} from "../utils/pushNotifications";
import styles from "../styles/_components/pushNotificationBanner.module.scss";

const DISMISSED_KEY = "push_notifications_dismissed";

const PushNotificationBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!isNotificationSupported()) return;
    if (isNotificationGranted()) return;
    if (Notification.permission === "denied") return;
    if (localStorage.getItem(DISMISSED_KEY) === "true") return;
    setVisible(true);
  }, []);

  const handleEnable = async () => {
    const granted = await requestNotificationPermission();
    if (granted) {
      setVisible(false);
    }
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <span className={styles.icon}>&#x1F514;</span>
        <p className={styles.text}>
          {"הפעל התראות פוש — קבל עדכונים חשובים ישירות לנייד, גם כשהאפליקציה סגורה"}
        </p>
        <button className={styles.enableBtn} onClick={handleEnable}>
          {"הפעל התראות"}
        </button>
      </div>
      <button className={styles.dismissBtn} onClick={handleDismiss}>
        &times;
      </button>
    </div>
  );
};

export default PushNotificationBanner;
